import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, Instagram } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/inquiries", form);
      toast.success("Message received — we'll be in touch soon.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 min-h-screen" data-testid="contact-page">
      <div className="max-w-6xl mx-auto px-6 md:px-10 pb-24 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <div className="overline text-primary/80">Get in touch</div>
          <h1 className="mt-4 font-display text-5xl md:text-6xl leading-[1.05]">Say hi.</h1>
          <p className="mt-6 text-muted-foreground text-lg">
            Have a question, need something bespoke, or just want to talk cocktails?
            We reply within 24 hours.
          </p>
          <ul className="mt-10 space-y-4">
            <li className="flex items-center gap-3"><Mail size={16} className="text-primary" /><span>pinkiesupcocktailbar@gmail.com</span></li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-primary" /><span>+1 (555) 555-0132</span></li>
            <li className="flex items-center gap-3"><Instagram size={16} className="text-primary" /><span>@Pinkie.Up.Cocktails</span></li>
          </ul>
        </div>

        <form onSubmit={submit} className="md:col-span-3 rounded-2xl border border-white/10 bg-card/40 p-8 md:p-10 space-y-5" data-testid="contact-form">
          <div>
            <Label className="overline">Name</Label>
            <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 bg-secondary/40 border-white/10" data-testid="contact-name" />
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <Label className="overline">Email</Label>
              <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 bg-secondary/40 border-white/10" data-testid="contact-email" />
            </div>
            <div>
              <Label className="overline">Phone (optional)</Label>
              <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-2 bg-secondary/40 border-white/10" data-testid="contact-phone" />
            </div>
          </div>
          <div>
            <Label className="overline">Message</Label>
            <Textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-2 bg-secondary/40 border-white/10" data-testid="contact-message" />
          </div>
          <Button type="submit" disabled={loading} className="rounded-full px-7 py-3 bg-primary text-primary-foreground hover:bg-primary/90" data-testid="contact-submit">
            {loading ? "Sending..." : "Send message"}
          </Button>
        </form>
      </div>
    </div>
  );
}
